import { render } from "./Home.vue?vue&type=template&id=2881d4d4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2881d4d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2881d4d4"

export default script